import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';
import {
    IMessageResponse,
    IResultResponse,
    ISubscriptionActionResponse,
    PauseSubscriptionRequestType,
} from 'api/types/response';

import { DISCOUNT_TYPES } from 'constants/subscriptions';

import ApiClientWellFunnel from 'services/api/ApiClientWellFunnel';

import {
    ICancelSubscriptionRequest,
    IDiscountSubscription,
    ISubscriptionFeedback,
    IUpdateSubscriptionData,
    SubscriptionPauseType,
} from 'types/subscription';

class SubscriptionsApiWellFunnel {
    getSubscriptions = async <Response = ISubscriptionWellfunnel[]>(): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.get<Response>('user/subscription');
    };

    unsubscribe = async <Data = ICancelSubscriptionRequest, Response = IResultResponse>(
        payload: Data
    ): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.post<Data, Response>('subscriptions/cancel', payload);
    };

    sendFeedback = async <Data = ISubscriptionFeedback, Response = IMessageResponse>(
        payload: Data
    ): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.post<Data, Response>('feedback/', payload);
    };

    resetSubscription = async <Data = IUpdateSubscriptionData, Response = ISubscriptionActionResponse>(
        payload: Data
    ): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.post<Data, Response>('subscriptions/reset', payload);
    };

    updateSubscription = async <Data = IUpdateSubscriptionData, Response = ISubscriptionActionResponse>(
        payload: Data
    ): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.post<Data, Response>('subscriptions/switch', payload);
    };

    restoreSubscription = async (payload: { id: string; provider: string }): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.post<typeof payload, Response>('subscriptions/restore', payload);
    };

    getDiscountSubscription = async <Response = IDiscountSubscription>(payload: {
        external_id: string;
        discount_type: DISCOUNT_TYPES;
        provider: string;
    }): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.post<typeof payload, Response>('products/discount', payload);
    };

    pauseSubscription = async (payload: PauseSubscriptionRequestType): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.post<typeof payload, Response>('subscriptions/pause', payload);
    };

    resumeSubscription = async (payload: { id: string; provider: string }): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.post<typeof payload, Response>('subscriptions/resume', payload);
    };

    setReminder = async (payload: { external_id: string; provider: string }): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.post<typeof payload, Response>('user/subscription/reminder', payload);
    };

    sendPauseStatus = async (payload: {
        external_id: string;
        pause_type: SubscriptionPauseType;
        provider: string;
    }): Promise<Partial<Response> | unknown> => {
        return await ApiClientWellFunnel.post<typeof payload, Response>('v2/events/pause-offer-activated', payload);
    };
}

export default SubscriptionsApiWellFunnel;
